export enum DataType {
  String = "String",
  Long = "Long",
  Integer = "Integer",
  Double = "Double",
  Date = "Date",
  Enum = "Enum"
}
